import { Breadcrumb, Button, Card, Form, Select, Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { AiOutlineLeft } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router";
import { amountFormat } from "../../services/common.service";
import { ReactComponent as TitleIcon } from "../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { accountListSelector } from "../../store/selectors/app.selector";
import ExportCollection from "./export-collection";
import ImportCollection from "./import-collection";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function Collection() {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("EXPORT");
  const [keyName, setKeyName] = useState("Export Collection");
  const accountList = useSelector(accountListSelector);






  const handleTabClick = (key) => {
    setActiveKey(key);
    if (key === "EXPORT") {
      setKeyName("Export Collection");
    }
    if (key === "DIRECT") {
      setKeyName("Direct Collection");
    }
    
  };

 

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/trade-finance")}>
              {" "}
              {t("navigation.trade_finance", {
                defaultValue: "Trade Finance",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/trade-finance")}>
              {" "}
              {t("navigation.collection", {
                defaultValue: "Collection",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {keyName}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {keyName}
            </h3>
          </div>
          
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.export_collection", {
              defaultValue: "Export Collection",
            })}
            key="EXPORT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.direct_collection", {
              defaultValue: "Direct Collection",
            })}
            key="DIRECT"
          ></Tabs.TabPane>
         
        </Tabs>
      </Card>
      {activeKey === "EXPORT" && (
        <ExportCollection />

      )}
      {activeKey === "DIRECT" && (
    <ImportCollection />

      )}
     

    </>
  );
}
